import React, { useId } from "react";
import PropTypes from "prop-types";

import ValidationMessage from "./ValidationMessage";

const FormField = ({ children, className = "", error, helpText, id, label, optional = false, required = false }) => {
  const generatedId = useId();
  const controlId = id || generatedId;
  const descriptionId = helpText ? `${controlId}-help` : undefined;
  const errorId = error ? `${controlId}-error` : undefined;

  return (
    <div className={["wsm-field", error && "wsm-field--error", className].filter(Boolean).join(" ")}>
      {label && (
        <label className="wsm-field__label" htmlFor={controlId}>
          <span>{label}</span>
          {required && <span className="wsm-field__required" aria-hidden="true">*</span>}
          {optional && <span className="wsm-field__optional">Optional</span>}
        </label>
      )}
      {typeof children === "function"
        ? children({
            id: controlId,
            "aria-describedby": [descriptionId, errorId].filter(Boolean).join(" ") || undefined,
            "aria-invalid": Boolean(error),
            required,
          })
        : children}
      {helpText && <p className="wsm-field__help" id={descriptionId}>{helpText}</p>}
      {error && <ValidationMessage className="wsm-field__error" id={errorId} message={error} />}
    </div>
  );
};

FormField.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  helpText: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.node,
  optional: PropTypes.bool,
  required: PropTypes.bool,
};

export default FormField;
